/**
 * In Process "errors only" mode: URL `errors_only=1` plus report:resume_workflow
 * (same capability used to restart FAILED workflows). Backend maps to failed_only.
 */
export function shouldAttachInProcessErrorsOnlyQuery(
  search: string,
  canResumeWorkflow: boolean
): boolean {
  if (!canResumeWorkflow) {
    return false;
  }
  const params = new URLSearchParams(search);
  return params.get("errors_only") === "1";
}
